export const googleMapsApiKey = 'AIzaSyD27XWPPAY3Zc1QfQo87ZWuMDPTOw1r-04';
